import React, { Component, Suspense, lazy } from "react";
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import classes from "./ReviewHotel.scss";
import HotelSummary from '../../components/Hotel/HotelSummary/HotelSummary';
import Addons from '../../components/Addons/Addons';
import Passengers from "../Passengers/Passengers";
import Payments from '../Payments/Payments';
import NavigationProgress from "../../components/NavigationProgress/NavigationProgress";
import Spinner from '../../components/UI/Spinner/Spinner';
import HeadingH4 from '../../components/UI/Headings/HeadingH4/HeadingH4';

import Media from 'react-media';
import ButtonProceedMobile from '../../components/UI/Button/ButtonProceedMobile/ButtonProceedMobile';
import * as hotelActions from '../../store/actions/index';
import * as paymentActions from '../../store/actions/index';

import fareBreakupIcon from '../../assets/images/farebreakup-icon.svg';
import Article from '../../containers/Article/Article';

class Review extends Component {

  componentWillMount() {
    this.props.onGetHotelReviewDetails(this.props.location.search);
  }

  FirstChildHandler = (props) => {
    const childrenArray = React.Children.toArray(props.children);
    return childrenArray[0] || null;
  }

  payButtonHandler = () => {
    const reviewDetails = {
      bookingType: "ONLINE",
      discountParams: {},
      eCashReedeemed: false,
      isFromBongo: "true",
      payMode: "",
      payType: "full",
      payoption: "cc",
      holdAndPay: false,
      priceId: this.props.reviewPriceId,
      propertyType: "HOTEL",
      roomGuests : this.props.guests,
      specialRequestFromCust: "",
      user: {
        emailId: this.props.user.email,
        mobileISDCode: this.props.user.mobileISD,
        mobileNumber: this.props.user.mobile
      },
    }

    let profileType = Object.keys(this.props.userProfile.moDetail)[0];
    let travellerSSOId = this.props.userProfile.moDetail[profileType].clientID;

    const paymentObject = {
      "product": "b2bdomhotel_newB2B",
      "servicesRequested": ["paymentOptionJSON","bookingDetails","balance"],
      "agentProfileType": profileType,
      "merchant": "yatra",
      "ssoToken": "539fbff0-2cf8-4232-a150-436b6cd438c2",
      "travellerSSOId": travellerSSOId
    }
    this.props.onSaveTravellerProfile(reviewDetails, paymentObject);
  }

  render() {
    let primaryContainer = null;
    let secondaryContainer = null;

    if (!this.props.reviewLoading) {
      console.log(this.props.reviewPrimary);
      primaryContainer = (
          <div className={classes.Inner}>
            {/* {
              this.props.reviewPrimary === 'review' ? 
              <Passengers lob="hotel" /> : this.props.reviewPrimary === 'addons' ? 
              <Addons /> : this.props.reviewPrimary === 'payments' ? 
              <Payments /> : null 
            } */}
            <Passengers lob='hotel'/>
            {/* <Suspense fallback={<div>Loading...</div>}>
              <Route path='/reviewHotel' component={() => <Passengers lob='hotel'/>}/>
              <Route path='/reviews/pay' component={Payments}/>
            </Suspense> */}
          </div>
      );

      secondaryContainer = (  
        this.props.reviewLoading ? <Spinner /> : <HotelSummary payButtonHandler={this.payButtonHandler} />
      )
    }

    return (
      <React.Fragment>
      <div style={{minHeight: this.props.reviewPrimary === "payments" ? 'calc(100vh - 5.8rem)' : '100vh'}} className={classes.Wrapper}>
        <div style={{
          transform: this.props.flowLogin ? 'translateX(0)' : 'translateX(-36rem)',
          position: 'fixed',
          top: '0',
          left: '0',
          transition: 'all .45s cubic-bezier(.4,0,.2,1)'
          }}>
          <Article/>
        </div>
        <section className={classes.Primary} style={{ transform: this.props.flowLogin ? 'translateX(36rem)' : 'none' }}>
          <div className={`${classes.Navigation} u-phoneHide`}> 
            <NavigationProgress lob="hotel" />
          </div>
          {this.props.reviewLoading ? <Spinner/> : primaryContainer}
            <Media query="(max-width: 900px)">
                  {matches => matches && this.props.reviewPrimary === 'review' ? 
                  <div className={classes.ProceedContainer}>
                    <div>
                      <HeadingH4 size={18} weight="Medium" color="White">You Pay &#8377; 9,772</HeadingH4>
                      {
                        !this.props.mobileFareBreakup ? <p className={`u-cursorPointer u-fontSize13 u-textColorFluorescentGreen`} onClick={() => this.props.onToggleMobileFareBreakup()}>
                        <img src={fareBreakupIcon} alt='Promo' className={classes.SmallImage}/>
                          Fare Breakup
                        </p> : null
                      }
                    </div>
                    {
                      !this.props.mobileFareBreakup ? <ButtonProceedMobile disabled={!this.props.isContinueButtonActive} count={this.props.paxCounter} onClick={() => console.log('Go To Addons')}>Continue</ButtonProceedMobile>
                        : <div className={classes.CloseButton} onClick={() => this.props.onToggleMobileFareBreakup()}>
                        <span>CLOSE</span>
                      </div>
                    }
                  </div> : this.props.reviewPrimary === 'addons' ? 
                  <div className={classes.ProceedContainer}>
                    <div>
                      <HeadingH4 size={18} weight="Medium" color="White">You Pay &#8377; 9,772</HeadingH4>
                      {
                        !this.props.mobileFareBreakup ? <p className={`u-cursorPointer u-fontSize13 u-textColorFluorescentGreen`} onClick={() => this.props.onToggleMobileFareBreakup()}>
                        <img src={fareBreakupIcon} alt='Fare Breakup' className={classes.SmallImage}/>
                        Fare Breakup
                      </p> : null
                      }
                    </div>
                    {
                      !this.props.mobileFareBreakup ? <ButtonProceedMobile onClick={() => console.log('Go To Payments')} disabled={!this.props.isButtonActive}>Pay Now</ButtonProceedMobile> : <div className={classes.CloseButton} onClick={() => this.props.onToggleMobileFareBreakup()}>
                      <span>CLOSE</span>
                    </div>
                    }
                  </div> : null }
            </Media>
        </section>
        <section className={[classes.Secondary, this.props.mobileFareBreakup ? classes.SecondaryMobile : null].join(' ')} style={{
            transform: this.props.flowLogin ? 'translateX(36rem)' : null,
            borderLeft: this.props.reviewPrimary === "payments" ? "none" : '#dee2ed'
          }}>
          {secondaryContainer}     
        </section>
      </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    reviewLoading: state.hotels.reviewLoading,
    flowLogin: state.auth.flowLogin ,
    reviewPriceId: state.hotels.reviewPriceId,
    guests: state.hotels.guests,
    user: state.farePrice.userParams.additionalContact,
    userProfile: state.auth.userProfile,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onGetHotelReviewDetails: (reviewParams) => dispatch(hotelActions.getHotelReviewDetails(reviewParams)),
    onSaveTravellerProfile: (reviewDetails, paymentObject) => dispatch(paymentActions.saveTravellerProfile(reviewDetails, paymentObject))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Review);



// WEBPACK FOOTER //
// ./src/containers/ReviewHotel/ReviewHotel.js